import React from 'react'

const BizCourtBook = () => {
  return (
    < >
      <div>
        <h1 className='text-2xl ml-3  text-[#272C34] font-bold'>Court bookings</h1>
        <div className='my-4 mx-2'>
          <div className='flex justify-between'>
            <div className='flex'>
              <h5 className='text-[12px] text-[#272C34] my-1'>See bookings for</h5>
              <select className='md:w-[18rem] w-[7rem] text-xs bg-[#FBFEFF] px-2 ml-3 h-[25px] border border-gray-300 rounded-lg'>
                <option>All</option>
                <option>ok</option>
              </select>
            </div>
            <div className='px-4 h-auto mx-1 w-auto bg-[#ecf1f4]  rounded-xl'><h5 className='text-[12px] text-[#272C34] py-1'>Total bookings: 569</h5></div>
          </div>


        </div>


        <div className=' bg-[#ecf1f4]  py-4 rounded-full'>

    
            <tr className='flex md:px-9 px-3 '>
              <td className=' px-1 w-[30px] md:w-[140px]'><h5 className='text-[12px] text-[#272C34] '>Sr. No</h5></td>
              <td className=' px-1 w-[60px] md:w-[190px]'><h5 className='text-[12px]   text-[#272C34] '>Player</h5></td>
              <td className='  px-1 w-[30px] md:w-[170px]'><h5 className='text-[12px]   text-[#272C34] '>No. of Bookings</h5></td>
              <td className='px-2 w-[100px] md:w-[250px] '><h5 className='text-[12px]   text-[#272C34] '>Court name</h5></td>
              <td className=' px-1 w-[80px] md:w-[190px]'><h5 className='text-[12px] text-[#272C34] '>Booking time</h5></td>
              <td className='px-1 w-[60px] md:w-[130px]'><h5 className='text-[12px] text-[#272C34] '>Action</h5></td>

            </tr>

        

        </div>


        <div>
          <div className='w-full my-3'>
          <tr className='flex md:px-9 px-3 my-4'>
              <td className=' px-1 w-[30px] md:w-[140px]'><h5 className='text-[12px] text-[#272C34] '>1</h5></td>
              <td className=' px-1 w-[60px] md:w-[190px]'><h5 className='text-[12px]   text-[#272C34] '>John Doe</h5></td>
              <td className='  px-1 w-[30px] md:w-[170px]'><h5 className='text-[12px]   text-[#272C34] '>3</h5></td>
              <td className='px-2 w-[100px] md:w-[250px] '><h5 className='text-[12px]   text-[#272C34] '>Court name</h5></td>
              <td className=' px-1 w-[80px] md:w-[190px]'><h5 className='text-[12px] text-[#272C34] '>11:00 - 12:00 pm</h5></td>
              <td className='px-1 w-[60px] md:w-[130px]'><h5 className='text-[12px] text-[#272C34] '><div className='flex'> <span className='bg-[#e8f4fe] rounded-full cursor-pointer  px-2  p-1'><i class="fa-solid fa-phone text-[#409bf5] text-xs"></i></span> <span className=' cursor-pointer bg-[#f9edee] rounded-full px-[10px]  p-1 mx-[2px] md:mx-2'><i class="fa-solid fa-xmark text-xs text-[#eb5757] "> </i></span></div></h5></td>

            </tr>

            <tr className='flex md:px-9 px-3 my-4'>
              <td className=' px-1 w-[30px] md:w-[140px]'><h5 className='text-[12px] text-[#272C34] '>2</h5></td>
              <td className=' px-1 w-[60px] md:w-[190px]'><h5 className='text-[12px]   text-[#272C34] '>John Doe</h5></td>
              <td className='  px-1 w-[30px] md:w-[170px]'><h5 className='text-[12px]   text-[#272C34] '>1</h5></td>
              <td className='px-2 w-[100px] md:w-[250px] '><h5 className='text-[12px]   text-[#272C34] '>Court name</h5></td>
              <td className=' px-1 w-[80px] md:w-[190px]'><h5 className='text-[12px] text-[#272C34] '>11:00 - 12:00 pm</h5></td>
              <td className='px-1 w-[60px] md:w-[130px]'><h5 className='text-[12px] text-[#272C34] '><div className='flex'> <span className='bg-[#e8f4fe] rounded-full cursor-pointer  px-2  p-1'><i class="fa-solid fa-phone text-[#409bf5] text-xs"></i></span> <span className=' cursor-pointer bg-[#f9edee] rounded-full px-[10px]  p-1 mx-[2px] md:mx-2'><i class="fa-solid fa-xmark text-xs text-[#eb5757] "> </i></span></div></h5></td>

            </tr>

            <tr className='flex md:px-9 px-3 my-4'>
              <td className=' px-1 w-[30px] md:w-[140px]'><h5 className='text-[12px] text-[#272C34] '>3</h5></td>
              <td className=' px-1 w-[60px] md:w-[190px]'><h5 className='text-[12px]   text-[#272C34] '>John Doe</h5></td>
              <td className='  px-1 w-[30px] md:w-[170px]'><h5 className='text-[12px]   text-[#272C34] '>2</h5></td>
              <td className='px-2 w-[100px] md:w-[250px] '><h5 className='text-[12px]   text-[#272C34] '>Court name</h5></td>
              <td className=' px-1 w-[80px] md:w-[190px]'><h5 className='text-[12px] text-[#272C34] '>11:00 - 12:00 pm</h5></td>
              <td className='px-1 w-[60px] md:w-[130px]'><h5 className='text-[12px] text-[#272C34] '><div className='flex'> <span className='bg-[#e8f4fe] rounded-full cursor-pointer  px-2  p-1'><i class="fa-solid fa-phone text-[#409bf5] text-xs"></i></span> <span className=' cursor-pointer bg-[#f9edee] rounded-full px-[10px]  p-1 mx-[2px] md:mx-2'><i class="fa-solid fa-xmark text-xs text-[#eb5757] "> </i></span></div></h5></td>

            </tr>

            <tr className='flex md:px-9 px-3 my-4'>
              <td className=' px-1 w-[30px] md:w-[140px]'><h5 className='text-[12px] text-[#272C34] '>4</h5></td>
              <td className=' px-1 w-[60px] md:w-[190px]'><h5 className='text-[12px]   text-[#272C34] '>John Doe</h5></td>
              <td className='  px-1 w-[30px] md:w-[170px]'><h5 className='text-[12px]   text-[#272C34] '>1</h5></td>
              <td className='px-2 w-[100px] md:w-[250px] '><h5 className='text-[12px]   text-[#272C34] '>Court name</h5></td>
              <td className=' px-1 w-[80px] md:w-[190px]'><h5 className='text-[12px] text-[#272C34] '>11:00 - 12:00 pm</h5></td>
              <td className='px-1 w-[60px] md:w-[130px]'><h5 className='text-[12px] text-[#272C34] '><div className='flex'> <span className='bg-[#e8f4fe] rounded-full cursor-pointer  px-2  p-1'><i class="fa-solid fa-phone text-[#409bf5] text-xs"></i></span> <span className=' cursor-pointer bg-[#f9edee] rounded-full px-[10px]  p-1 mx-[2px] md:mx-2'><i class="fa-solid fa-xmark text-xs text-[#eb5757] "> </i></span></div></h5></td>

            </tr>

            <tr className='flex md:px-9 px-3 my-4'>
              <td className=' px-1 w-[30px] md:w-[140px]'><h5 className='text-[12px] text-[#272C34] '>5</h5></td>
              <td className=' px-1 w-[60px] md:w-[190px]'><h5 className='text-[12px]   text-[#272C34] '>John Doe</h5></td>
              <td className='  px-1 w-[30px] md:w-[170px]'><h5 className='text-[12px]   text-[#272C34] '>4</h5></td>
              <td className='px-2 w-[100px] md:w-[250px] '><h5 className='text-[12px]   text-[#272C34] '>Court name</h5></td>
              <td className=' px-1 w-[80px] md:w-[190px]'><h5 className='text-[12px] text-[#272C34] '>11:00 - 12:00 pm</h5></td>
              <td className='px-1 w-[60px] md:w-[130px]'><h5 className='text-[12px] text-[#272C34] '><div className='flex'> <span className='bg-[#e8f4fe] rounded-full cursor-pointer  px-2  p-1'><i class="fa-solid fa-phone text-[#409bf5] text-xs"></i></span> <span className=' cursor-pointer bg-[#f9edee] rounded-full px-[10px]  p-1 mx-[2px] md:mx-2'><i class="fa-solid fa-xmark text-xs text-[#eb5757] "> </i></span></div></h5></td>

            </tr>

            <tr className='flex md:px-9 px-3 my-4'>
              <td className=' px-1 w-[30px] md:w-[140px]'><h5 className='text-[12px] text-[#272C34] '>6</h5></td>
              <td className=' px-1 w-[60px] md:w-[190px]'><h5 className='text-[12px]   text-[#272C34] '>John Doe</h5></td>
              <td className='  px-1 w-[30px] md:w-[170px]'><h5 className='text-[12px]   text-[#272C34] '>1</h5></td>
              <td className='px-2 w-[100px] md:w-[250px] '><h5 className='text-[12px]   text-[#272C34] '>Court name</h5></td>
              <td className=' px-1 w-[80px] md:w-[190px]'><h5 className='text-[12px] text-[#272C34] '>11:00 - 12:00 pm</h5></td>
              <td className='px-1 w-[60px] md:w-[130px]'><h5 className='text-[12px] text-[#272C34] '><div className='flex'> <span className='bg-[#e8f4fe] rounded-full cursor-pointer  px-2  p-1'><i class="fa-solid fa-phone text-[#409bf5] text-xs"></i></span> <span className=' cursor-pointer bg-[#f9edee] rounded-full px-[10px]  p-1 mx-[2px] md:mx-2'><i class="fa-solid fa-xmark text-xs text-[#eb5757] "> </i></span></div></h5></td>

            </tr>

            <tr className='flex md:px-9 px-3 my-4'>
              <td className=' px-1 w-[30px] md:w-[140px]'><h5 className='text-[12px] text-[#272C34] '>7</h5></td>
              <td className=' px-1 w-[60px] md:w-[190px]'><h5 className='text-[12px]   text-[#272C34] '>John Doe</h5></td>
              <td className='  px-1 w-[30px] md:w-[170px]'><h5 className='text-[12px]   text-[#272C34] '>3</h5></td>
              <td className='px-2 w-[100px] md:w-[250px] '><h5 className='text-[12px]   text-[#272C34] '>Court name</h5></td>
              <td className=' px-1 w-[80px] md:w-[190px]'><h5 className='text-[12px] text-[#272C34] '>11:00 - 12:00 pm</h5></td>
              <td className='px-1 w-[60px] md:w-[130px]'><h5 className='text-[12px] text-[#272C34] '><div className='flex'> <span className='bg-[#e8f4fe] rounded-full cursor-pointer  px-2  p-1'><i class="fa-solid fa-phone text-[#409bf5] text-xs"></i></span> <span className=' cursor-pointer bg-[#f9edee] rounded-full px-[10px]  p-1 mx-[2px] md:mx-2'><i class="fa-solid fa-xmark text-xs text-[#eb5757] "> </i></span></div></h5></td>

            </tr>

            <tr className='flex md:px-9 px-3 my-4'>
              <td className=' px-1 w-[30px] md:w-[140px]'><h5 className='text-[12px] text-[#272C34] '>8</h5></td>
              <td className=' px-1 w-[60px] md:w-[190px]'><h5 className='text-[12px]   text-[#272C34] '>John Doe</h5></td>
              <td className='  px-1 w-[30px] md:w-[170px]'><h5 className='text-[12px]   text-[#272C34] '>2</h5></td>
              <td className='px-2 w-[100px] md:w-[250px] '><h5 className='text-[12px]   text-[#272C34] '>Court name</h5></td>
              <td className=' px-1 w-[80px] md:w-[190px]'><h5 className='text-[12px] text-[#272C34] '>11:00 - 12:00 pm</h5></td>
              <td className='px-1 w-[60px] md:w-[130px]'><h5 className='text-[12px] text-[#272C34] '><div className='flex'> <span className='bg-[#e8f4fe] rounded-full cursor-pointer  px-2  p-1'><i class="fa-solid fa-phone text-[#409bf5] text-xs"></i></span> <span className=' cursor-pointer bg-[#f9edee] rounded-full px-[10px]  p-1 mx-[2px] md:mx-2'><i class="fa-solid fa-xmark text-xs text-[#eb5757] "> </i></span></div></h5></td>

            </tr>

            <tr className='flex md:px-9 px-3 my-4'>
              <td className=' px-1 w-[30px] md:w-[140px]'><h5 className='text-[12px] text-[#272C34] '>9</h5></td>
              <td className=' px-1 w-[60px] md:w-[190px]'><h5 className='text-[12px]   text-[#272C34] '>John Doe</h5></td>
              <td className='  px-1 w-[30px] md:w-[170px]'><h5 className='text-[12px]   text-[#272C34] '>1</h5></td>
              <td className='px-2 w-[100px] md:w-[250px] '><h5 className='text-[12px]   text-[#272C34] '>Court name</h5></td>
              <td className=' px-1 w-[80px] md:w-[190px]'><h5 className='text-[12px] text-[#272C34] '>11:00 - 12:00 pm</h5></td>
              <td className='px-1 w-[60px] md:w-[130px]'><h5 className='text-[12px] text-[#272C34] '><div className='flex'> <span className='bg-[#e8f4fe] rounded-full cursor-pointer  px-2  p-1'><i class="fa-solid fa-phone text-[#409bf5] text-xs"></i></span> <span className=' cursor-pointer bg-[#f9edee] rounded-full px-[10px]  p-1 mx-[2px] md:mx-2'><i class="fa-solid fa-xmark text-xs text-[#eb5757] "> </i></span></div></h5></td>

            </tr>

            <tr className='flex md:px-9 px-3 my-4'>
              <td className=' px-1 w-[30px] md:w-[140px]'><h5 className='text-[12px] text-[#272C34] '>10</h5></td>
              <td className=' px-1 w-[60px] md:w-[190px]'><h5 className='text-[12px]   text-[#272C34] '>John Doe</h5></td>
              <td className='  px-1 w-[30px] md:w-[170px]'><h5 className='text-[12px]   text-[#272C34] '>3</h5></td>
              <td className='px-2 w-[100px] md:w-[250px] '><h5 className='text-[12px]   text-[#272C34] '>Court name</h5></td>
              <td className=' px-1 w-[80px] md:w-[190px]'><h5 className='text-[12px] text-[#272C34] '>11:00 - 12:00 pm</h5></td>
              <td className='px-1 w-[60px] md:w-[130px]'><h5 className='text-[12px] text-[#272C34] '><div className='flex'> <span className='bg-[#e8f4fe] rounded-full cursor-pointer  px-2  p-1'><i class="fa-solid fa-phone text-[#409bf5] text-xs"></i></span> <span className=' cursor-pointer bg-[#f9edee] rounded-full px-[10px]  p-1 mx-[2px] md:mx-2'><i class="fa-solid fa-xmark text-xs text-[#eb5757] "> </i></span></div></h5></td>

            </tr>


          </div>
        </div>
        {/* pagination  */}

        <div className='flex justify-between mt-3 md:mt-9'>
          <nav aria-label="Page navigation example">
            <ul class="inline-flex items-center -space-x-px">
              <li>
                <a href="#" class="block py-2 px-3 ml-0 leading-tight text-gray-500  text-[12px]  rounded-l-lg  hover:bg-gray-100 hover:text-gray-700    ">
                  <span class="sr-only">Previous</span>
                  <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd"></path></svg>
                </a>
              </li>
              <li>
                <a href="#" class="py-2 px-3 leading-tight  text-[12px]    hover:bg-gray-100 hover:text-gray-700    ">1</a>
              </li>
              <li>
                <a href="#" class="py-2 px-3 leading-tight text-gray-500  text-[12px]   hover:bg-gray-100 hover:text-gray-700    ">2</a>
              </li>
              <li>
                <a href="#" aria-current="page" class=" text-gray-500  py-2 px-3 leading-tight text-[12px]  hover:bg-blue-100 hover:text-[#409bf5] ">3</a>
              </li>
              <li>
                <a href="#" class="py-2 px-3 leading-tight text-gray-500  text-[12px]   hover:bg-gray-100 hover:text-gray-700    ">4</a>
              </li>

              <li>
                <a href="#" class="py-2 px-3 leading-tight text-gray-500  text-[12px]   hover:bg-gray-100 hover:text-gray-700    ">...</a>
              </li>
              <li>
                <a href="#" class="block py-2 px-3 leading-tight text-gray-500  text-[12px]  rounded-r-lg  hover:bg-gray-100 hover:text-gray-700  ">
                  <span class="sr-only">Next</span>
                  <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg>
                </a>
              </li>
            </ul>
          </nav>
          <h3 className='text-gray-500 text-[12px] mt-3'>1 of 729</h3>
        </div>






      </div>
    </>
  )
}

export default BizCourtBook